import React from 'react'
import './App.css'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from './Pages/Home'
import 'bootstrap/dist/css/bootstrap.min.css';
import Page from './Pages/Page';
import LandingPage from './Pages/LandingPage';
import Task from './Pages/Task';

export default function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path='/home' element={<Home />} />
          <Route path='/landingpage' element={<LandingPage />} />
          <Route path='/' element={<Page />} />
          <Route path='/tasks' element={<Task />} />
        </Routes>
      </BrowserRouter>
    </>
  )
}
